import {Component} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {FileTableService} from './file-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {EnumService} from '@lib-services/enum.service';
import {FileTypeEnum} from '@libs-enums/file-type.enum';

@Component({
    selector: 'app-file',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './file.component.html',
    styleUrl: './file.component.scss'
})
export class FileComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'createdAt', title: 'Дата создания', type: Date },
            { name: 'link', title: 'Ссылка'},
            { name: 'name', title: 'Название' },
            { name: 'type', title: 'Тип' },
        ]
    });
    filterConfig: FilterConfig[];

    constructor(protected fileTableService: FileTableService, private enumService: EnumService) {
        this.filterConfig = [
            {
                type: 'datepicker',
                label: 'Дата создания',
                name: 'createdAt'
            },
            {
                type: 'dropdown',
                label: 'Тип',
                name: 'type',
                options: this.enumService.enumToArrSelects(FileTypeEnum),
            },
        ];
    }

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.fileTableService.updateData(this.tableConfig);
    }
}
